import { motion } from "framer-motion";
import { Truck } from "lucide-react";

export const DeliveryBanner = ({ onVerify }) => (
  <section id="consegna" className="px-3 md:px-6 py-8 max-w-6xl mx-auto" data-testid="delivery-banner-section">
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="relative overflow-hidden rounded-2xl bg-fr-navy p-5 md:p-7 flex flex-col md:flex-row md:items-center gap-4"
      data-testid="delivery-banner"
    >
      <div className="absolute -right-10 -top-14 h-44 w-44 rounded-full bg-white/5" />
      <div className="absolute -right-2 bottom-[-70px] h-36 w-36 rounded-full bg-white/5" />
      <div className="flex items-start md:items-center gap-3.5 flex-1">
        <span className="hidden md:flex h-11 w-11 rounded-full bg-white/10 items-center justify-center shrink-0">
          <Truck size={20} className="text-white" />
        </span>
        <div>
          <p className="text-white font-extrabold text-base md:text-xl tracking-tight" data-testid="delivery-banner-title">
            Consegna gratuita da 5 a 90 minuti!
          </p>
          <p className="text-white/70 text-xs md:text-sm mt-0.5" data-testid="delivery-banner-subtitle">
            Aeroporto, stazioni, hotel, B&B e casa — il tempo esatto dipende dalla distanza (es. Napoli centro 5-15 min).
          </p>
        </div>
      </div>
      <button
        onClick={onVerify}
        className="rounded-xl bg-white text-fr-navy font-bold text-sm px-5 py-3 hover:bg-gray-100 active:scale-[0.98] transition-all self-start md:self-auto"
        data-testid="delivery-coverage-button"
      >
        Verifica copertura
      </button>
    </motion.div>
  </section>
);

export default DeliveryBanner;
